/*
 * Reset view all button higlihts
 */
export const resetViewAll = () => {
    const nodeList = document.querySelectorAll('.filters-sorting__view-all');

    for (let i = 0; i < nodeList.length; i++) {
        nodeList[i].classList.remove('filters-sorting__view-all--highlight');
    }
};

export default resetViewAll;
